import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {NavItem} from '@shared/menu-list-item/nav-item';
import {Router} from '@angular/router';
import {NavService} from '@shared/menu-list-item/nav.service';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)'),
      ),
    ]),
  ],
})
export class MenuListItemComponent implements OnInit {
  expanded = false;
  @HostBinding('attr.aria-expanded') get ariaExpanded() {
    return this.expanded;
  }
  @Input() item: NavItem;
  @Input() depth: number;

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        this.expanded = this.isActive();
      }
    });
  }

  isActive(): boolean {
    if (!this.item.route) {
      return false;
    }
    const primaryPath = this.getPrimaryPath();
    // Exact match on primary path (ignores auxiliary outlets like popup)
    if (primaryPath === this.item.route) {
      return true;
    }
    // Check additional activeRoutes (prefix match on clean primary path)
    if (this.item.activeRoutes?.length) {
      return this.item.activeRoutes.some((route) =>
        primaryPath.startsWith(route),
      );
    }
    return false;
  }

  private getPrimaryPath(): string {
    const urlTree = this.router.parseUrl(this.router.url);
    const primary = urlTree.root.children['primary'];
    return primary ? '/' + primary.segments.map((s) => s.path).join('/') : '/';
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (item.route) {
        this.router.navigate([item.route]);
      }
      this.navService.closeNav();
      if (typeof item.click === 'function') {
        item.click();
      }
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
